import { Navigate } from "react-router-dom";
import { DashboardTemplate } from "../components/template/DashboardTemplate";
import { readAccessToken } from "../common/functions/authFunctions";

export default function HomePage() {
  const accessToken = readAccessToken();
  if (accessToken) {
    return <DashboardTemplate />;
  } else {
    return <Navigate to="/auth/login" />;
  }
}
